import { alpha } from "@mui/material/styles";


export const primary = {
    50: "#fff1f1",
    100: "#ffdfdf",
    200: "#ffc5c5",
    300: "#f88e91",
    400: "#f15459",
    500: "#e30613", // MAIN
    600: "#c8030f",
    700: "#a6000a",
    800: "#890008",
    900: "#740006",
};

export const secondary = {
    50: "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155", // MAIN
    800: "#1e293b",
    900: "#0f172a",
};

export const neutrals = {
    50: "#FAFAFA",
    100: "#F5F5F5",
    200: "#EEEEEE",
    300: "#E0E0E0",
    400: "#BDBDBD",
    500: "#9E9E9E",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
};

const getDesignTokens = (mode) => ({
    palette: {
        mode,
        primary: {
            light: primary[300],
            main: primary[500],
            dark: primary[700],
            contrastText: "#fff",
        },
        secondary: {
            light: secondary[400],
            main: secondary[700],
            dark: secondary[900],
            contrastText: "#fff",
        },
        background: {
            default: mode === "light" ? "#fcfcfc" : "#0f172a",
            paper: mode === "light" ? "#ffffff" : "#1e293b",
        },
        divider: mode === "light" ? alpha(secondary[500], 0.12) : alpha(secondary[100], 0.12),
        text: {
            primary: mode === "light" ? secondary[900] : "#fff",
            secondary: mode === "light" ? secondary[500] : secondary[300],
        },
    },
    shape: {
        borderRadius: 6,
    },
    typography: {
        fontFamily: ['"Poppins"', '"system-ui"', '"-apple-system"', '"Segoe UI"', '"Roboto"', "sans-serif"].join(","),
        h1: { fontSize: "var(--fs-xl)", fontWeight: 700 },
        h2: { fontSize: "var(--fs-lg)", fontWeight: 700 },
        h3: { fontSize: "var(--fs-md)", fontWeight: 600 },
        h4: { fontSize: "var(--fs-md)", fontWeight: 600 },
        h5: { fontSize: "var(--fs-md)", fontWeight: 600 },
        h6: { fontSize: "var(--fs-md)", fontWeight: 600 },
        subtitle1: { fontSize: "var(--fs-md)", fontWeight: 500 },
        subtitle2: { fontSize: "var(--fs-sm)", fontWeight: 500 },
        body1: { fontSize: "var(--fs-md)", lineHeight: 1.5, color: secondary[600] },
        body2: { fontSize: "var(--fs-sm)", lineHeight: 1.5 },
        button: {
            textTransform: "none",
            fontWeight: 600,
            fontSize: "var(--fs-sm)",
        },
        caption: { fontSize: "var(--fs-xs)", color: secondary[400] },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: "none",
                    "&:hover": { boxShadow: "none" },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                    boxShadow: "0px 1px 3px rgba(0,0,0,0.05), 0px 1px 2px rgba(0,0,0,0.03)",
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: mode === "light" ? "#e2e8f0" : "#334155",
                    },
                },
            },
        },
    },
});

export default function getTheme(mode) {
    return getDesignTokens(mode);
}